/** Комнаты меняют не только в колонке комнат, но и из «Информации о группе» (создание) — realtime-событий
 *  комнат нет, поэтому колонка подписывается на это браузерное событие и перечитывает список. */
const EVENT = 'hc-rooms-changed';

export function notifyRoomsChanged(chatId: string): void {
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: chatId }));
}

export function onRoomsChanged(handler: (chatId: string) => void): () => void {
  const listener = (e: Event) => handler((e as CustomEvent<string>).detail);
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
